'use client';
import {
  TableCell,
  TableCellProps,
  TableRow,
  Table,
  TableRowProps,
} from '@mui/material';
import { CSSProperties } from 'react';

import { Announcement, Autorenew } from '../../icons';
import { styled } from '../../styles';

export const Th = styled(TableCell)<TableCellProps>(({ theme }) => ({
  padding: theme.spacing(3, 1),
}));

export const HeaderTableRow = styled(TableRow)(({ theme }) => ({
  'th:first-of-type': {
    paddingLeft: theme.spacing(4),
    paddingRight: theme.spacing(4),
  },
}));

export const StyledTableRow = styled(TableRow)<TableRowProps>(({ theme }) => ({
  height: theme.spacing(18),
  borderRadius: theme.spacing(2),
  borderStyle: 'none solid solid none',

  background: theme.palette.surface2,
  whiteSpace: 'nowrap',
  cursor: 'pointer',

  td: {
    padding: theme.spacing(0, 1),
    borderTop: '1px solid transparent',
    borderBottom: '1px solid transparent',
  },

  'td:first-of-type': {
    paddingLeft: theme.spacing(4),
    border: '1px solid transparent',
    borderRadius: theme.spacing(2, 0, 0, 2),
  },
  'td:last-of-type': {
    paddingRight: theme.spacing(4),
    border: '1px solid transparent',
    borderRadius: theme.spacing(0, 2, 2, 0),
  },

  '&:hover td': {
    borderTopColor: theme.palette.blue[700],
    borderBottomColor: theme.palette.blue[700],
  },
  '&:hover td:first-of-type': {
    borderInlineStartColor: theme.palette.blue[700],
  },
  '&:hover td:last-of-type': {
    borderInlineEndColor: theme.palette.blue[700],
  },
}));

export const StyledTable = styled(Table)(({ theme }) => ({
  borderCollapse: 'separate',
  borderSpacing: theme.spacing(0, 2),
  tableLayout: 'fixed',
}));

export const StyledTableCell = styled(TableCell)(() => ({
  overflow: 'hidden',
}));

export const StyledEmptyTableRow = styled(StyledTableRow)(({ theme }) => ({
  'td:first-of-type': { borderRadius: theme.spacing(4), textAlign: 'center' },
}));

export const StyledEmptyTableCell = styled(StyledTableCell)(({ theme }) => ({
  textAlign: 'center',
  ...(theme.typography.body1 as CSSProperties),
  color: theme.palette.text3,
}));

export const StyledLoadingTableCell = styled(StyledTableCell)(({ theme }) => ({
  padding: theme.spacing(0, 4),
}));

export const TableRefreshDataRowIcon = styled(Announcement)(({ theme }) => ({
  width: theme.spacing(6),
  height: theme.spacing(6),
  color: theme.palette.yellow[700],
  marginRight: theme.spacing(2),
}));

export const TableRefreshDataButtonIcon = styled(Autorenew)(({ theme }) => ({
  width: theme.spacing(6),
  height: theme.spacing(6),
  color: theme.palette.blue[700],
}));

export const Row = styled.div(
  () =>
    ({
      display: 'flex',
      flexDirection: 'row',
      alignItems: 'center',
    } as const),
);

export const TableRefreshDataContainer = styled(Row)(({ theme }) => ({
  display: 'flex',
  alignItems: 'center',
  justifyContent: 'center',
  gap: theme.spacing(4),
}));
